// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"94":"6da1995d","201":"eaf61604","685":"dded4324","697":"b9fe6b26"}[chunkId] + ".css";
};